import React from 'react';
import { Routes, Route, Navigate } from "react-router-dom";
import { ProtectedRoute } from './route';
import Login from '../pages/LoginPage/Login';
import Signup from '../pages/SignupPage/Signup';
import CourseDetails from '../pages/DashBoardPages/Components/CourseDetails';
import QuizScreen from '../pages/DashBoardPages/Components/QuizScreen';
import ResultScreen from '../pages/DashBoardPages/Components/ResultScreen';
import Editprofile from '../pages/DashBoardPages/Components/Editprofile';
import OtpScreen from '../pages/OtpAndEmailScreen/OtpScreen';
import EmailScreen from '../pages/OtpAndEmailScreen/EmailScreen';
import StudentDashboard from '../pages/DashBoardPages/Components/StudentDashboard';
import TeacherDashboard from '../pages/DashBoardPages/Components/TeacherDashboard';
import AdminDashboard from '../pages/DashBoardPages/Components/AdminDashboard';
import userStore from '../zustand/store/userStore';
import TeacherRegistration from '../pages/DashBoardPages/Components/TeacherRegistration';
import Announcement from '../pages/DashBoardPages/Components/Announcement';
import TeacherDetails from '../pages/DashBoardPages/Components/TeacherDetails';
import StudentDetails from '../pages/DashBoardPages/Components/StudentDetails';
import AddCourse from '../pages/DashBoardPages/Components/AddCourse';
import TeacherCourseDetails from '../pages/DashBoardPages/Components/TeacherCourseDetails';
import EnrollCourses from '../pages/DashBoardPages/Components/EnrollCourses';
import ViewLectures from '../pages/DashBoardPages/Components/ViewLectures';
import ReportQuiz from '../pages/DashBoardPages/Components/ReportQuiz';
import ChatLayout from '../components/Dashboard/chat/ChatLayout';
import ParentDashboard from '../pages/DashBoardPages/Components/ParentDashboard';
import LayoutMain from './Layout/LayoutMain';
import LandingPage from '../pages/LandingPage/LandingPage';
import Notification from '../components/Dashboard/Notification';

const getDashboardRoute = (role) => {
    if (role === 'student') return "/student-dashboard";
    if (role === 'teacher') return "/teacher-dashboard";
    if (role === 'admin') return "/admin-dashboard";
    if (role === 'parent') return "/parent-dashboard";
    return "/home";
};

const Routers = () => {
    const { authToken, user } = userStore();

    return (
        <Routes>
            <Route path="/" element={<Navigate to={authToken ? getDashboardRoute(user?.role) : "/home"} />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={authToken ? <Navigate to={getDashboardRoute(user?.role)} /> : <Signup />} />
            <Route path="/otp-verify" element={<OtpScreen />} />
            <Route path="/email-screen" element={<EmailScreen />} />
            <Route
                path="/home"
                element={
                    authToken ? (
                        <Navigate to={getDashboardRoute(user?.role)} />
                    ) : (
                        <LandingPage />
                    )
                }
            />

            <Route element={<LayoutMain />}>
                <Route path="/student-dashboard" element={<ProtectedRoute element={<StudentDashboard />} allowedRoles={['student']} />} />
                <Route path="/teacher-dashboard" element={<ProtectedRoute element={<TeacherDashboard />} allowedRoles={['teacher']} />} />
                <Route path="/admin-dashboard" element={<ProtectedRoute element={<AdminDashboard />} allowedRoles={['admin']} />} />
                <Route path="/parent-dashboard" element={<ProtectedRoute element={<ParentDashboard />} allowedRoles={['parent']} />} />

                <Route path="/view-course" element={<ProtectedRoute element={<CourseDetails />} allowedRoles={['student', 'teacher', 'admin']} />} />
                <Route path="/quiz" element={<ProtectedRoute element={<QuizScreen />} allowedRoles={['student']} />} />
                <Route path="/result" element={<ProtectedRoute element={<ResultScreen />} allowedRoles={['admin','student', 'teacher']} />} />
                <Route path="/profile" element={<ProtectedRoute element={<Editprofile />} allowedRoles={['student', 'teacher', 'admin', 'parent']} />} />
                <Route path="/announcement" element={<ProtectedRoute element={<Announcement />} allowedRoles={['admin']} />} />
                <Route path="/add-course" element={<ProtectedRoute element={<AddCourse />} allowedRoles={['teacher']} />} />
                <Route path="/course-details" element={<ProtectedRoute element={<TeacherCourseDetails />} allowedRoles={['teacher']} />} />
                <Route path="/teacherRegistration" element={<ProtectedRoute element={<TeacherRegistration />} allowedRoles={['admin']} />} />
                <Route path="/teacher-details" element={<ProtectedRoute element={<TeacherDetails />} allowedRoles={['admin']} />} />
                <Route path="/student-details" element={<ProtectedRoute element={<StudentDetails />} allowedRoles={['admin']} />} />
                <Route path="/enroll-courses" element={<ProtectedRoute element={<EnrollCourses />} allowedRoles={['student']} />} />
                <Route path="/view-lectures" element={<ProtectedRoute element={<ViewLectures />} allowedRoles={['student']} />} />
                <Route path="/view-chapter-report" element={<ProtectedRoute element={<ReportQuiz />} allowedRoles={['admin','student', 'teacher', 'parent']} />} />
                <Route path="/messages" element={<ProtectedRoute element={<ChatLayout />} allowedRoles={['student', 'teacher', 'admin', 'parent']} />} />
                <Route path="/notification" element={<ProtectedRoute element={<Notification />} allowedRoles={['student', 'teacher', 'admin', 'parent']} />} />
            </Route>

            <Route path="*" element={<Navigate to={authToken ? getDashboardRoute(user?.role) : "/login"} />} />
        </Routes>
    );
};

export default Routers;
